export default __webpack_public_path__ + "50d25f6.png";